export const parametroTypes = {
    TIPO_DOCUMENTO_RESET: '[Tipo_Documento] RESET',
    TIPO_DOCUMENTO_GET_START: '[Tipo_Documento] GET_START',
    TIPO_DOCUMENTO_GET_COMPLETE: '[Tipo_Documento] GET_COMPLETE',
    TIPO_DOCUMENTO_GET_ERROR: '[Tipo_Documento] GET_ERROR',
    
    TIPO_INST_EDU_RESET: '[Tipo_Inst_Edu] RESET',
    TIPO_INST_EDU_GET_START: '[Tipo_Inst_Edu] GET_START',
    TIPO_INST_EDU_GET_COMPLETE: '[Tipo_Inst_Edu] GET_COMPLETE',
    TIPO_INST_EDU_GET_ERROR: '[Tipo_Inst_Edu] GET_ERROR',
    
    NACIONALIDAD_RESET: '[Nacionalidad] RESET',
    NACIONALIDAD_GET_START: '[Nacionalidad] GET_START',
    NACIONALIDAD_GET_COMPLETE: '[Nacionalidad] GET_COMPLETE',
    NACIONALIDAD_GET_ERROR: '[Nacionalidad] GET_ERROR',
}